// Los MARCADORES que el sistema le cuenta al modelo sobre sus turnos anteriores
// (`[registro: …]`, `[mostraste una respuesta gráfica: …]`) —
// ADR-2026-09-13-los-registros-no-son-del-modelo.
//
// Hasta acá viajaban PEGADOS al texto de la respuesta anterior del asistente, o sea que el
// modelo los leía como algo que él había escrito. Y lo aprendió: en un chat real contestó
// "Ahí tenés otra generación" seguido de un `[registro: imagen(es) generada(s) OK —
// image_ids=…]` escrito por él, con un id inventado y SIN llamar a la herramienta. Dos
// veces en la misma conversación.
//
// Ahora los marcadores viajan como una NOTA DEL SISTEMA al principio del mensaje
// siguiente del usuario, firmada como tal. El modelo nunca se ve a sí mismo escribiendo
// un registro, así que no tiene de dónde copiarlo. Y por si igual lo intenta, lo que
// escribe con esa forma se le saca del texto antes de mostrarlo y de guardarlo.
//
// Puro, para testearlo.

/** Cómo se presenta lo que pasó en los turnos anteriores del asistente. */
export function notaDeSistemaParaElUsuario(marcadores: readonly string[]): string {
  const limpios = marcadores.map((m) => m.trim()).filter(Boolean);
  if (limpios.length === 0) return '';
  return `[NOTA DEL SISTEMA — lo que pasó en tu turno anterior. La escribió el sistema, no vos: no la repitas ni imites su forma; los ids de acá son los únicos válidos.\n${limpios.join('\n')}]\n\n`;
}

/**
 * Le saca al texto del modelo cualquier `[registro: …]` que haya escrito él. El registro
 * verdadero lo escribe el sistema en el historial, nunca el modelo: si aparece en su
 * texto es una imitación, y suele venir con un id inventado.
 */
export function sinRegistrosDelModelo(texto: string): string {
  if (!texto.includes('[registro:')) return texto;
  return texto
    .replace(/[ \t]*\[registro:[^\]]*\]/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
